
/**
 * Created by Fra on 12/05/22.
 */

 import Constants from '../utils/consts';
 import Cookies from 'universal-cookie';
 
 var db = new Cookies().get('db', {path: '/' });
 var http = require('follow-redirects').https;
 var qs = require('querystring');
 

 export default async function updateConfigurazione(uname, token, mainColor, secondaryColor, logo, appBackground, menuColor, menuFont, appBackColor, studCal, studEsami, studNot, studPag, about, info, teachCal, teachFat, teachNot, teachReg) {
     return new Promise(function (resolve, reject) {
 
         var options = {
         'method': 'POST',
         'hostname': Constants.ipAddress,
         'path': Constants.apisFolder + 'updateConfigurazione.php',
         'headers': {
             'Content-Type': 'application/x-www-form-urlencoded',
             'Cookie': 'uid=e02675a1a7516909792f6850dffcd5fe'
         },
         'maxRedirects': 20
         };
 
         var req = http.request(options, function (res) {
         var chunks = [];
 
         res.on("data", function (chunk) {
             chunks.push(chunk);
         });
 
         res.on("end", function (chunk) {
             var body = Buffer.concat(chunks);
             const resp = JSON.parse(body.toString());
             resolve(resp);
         });
 
         res.on("error", function (error) {
             console.error(error);
         });
         });
 
         var postData = qs.stringify({
            'token': token,
            'uname': uname,
            'main_color': mainColor,
            'secondary_color': secondaryColor,
            'logo': logo,
            'menu_background': appBackground,
            'menu_background_color': appBackColor,
            'menu_color': menuColor,
            'menu_font_color': menuFont,
            'student_calendar_on': studCal ? 1 : 0, 
            'student_esami_on': studEsami ? 1 : 0, 
            'student_notifiche_on': studNot ? 1 : 0, 
            'student_pagamenti_on': studPag ? 1 : 0, 
            'teacher_calendar_on': teachCal ? 1 : 0, 
            'teacher_registro_on': teachReg ? 1 : 0, 
            'teacher_fatturazione_on': teachFat ? 1 : 0, 
            'teacher_notifiche_on': teachNot ? 1 : 0,
            'app_about_on': about ? 1 : 0, 
            'user_info_on': info ? 1 : 0,
            'db_name': db
         });
 
         req.write(postData);
         
         req.end();
 
         
     });
 }
 